/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiIntValues
 */
export interface ApiIntValues {
  /**
   *
   * @type {Array<number>}
   * @memberof ApiIntValues
   */
  values?: Array<number>;
}

/**
 * Check if a given object implements the ApiIntValues interface.
 */
export function instanceOfApiIntValues(value: object): value is ApiIntValues {
  return true;
}

export function ApiIntValuesFromJSON(json: any): ApiIntValues {
  return ApiIntValuesFromJSONTyped(json, false);
}

export function ApiIntValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiIntValues {
  if (json == null) {
    return json;
  }
  return {
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function ApiIntValuesToJSON(json: any): ApiIntValues {
  return ApiIntValuesToJSONTyped(json, false);
}

export function ApiIntValuesToJSONTyped(
  value?: ApiIntValues | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    values: value['values'],
  };
}
